import { PriorityContactViewDto } from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const priorityContactRequests = {
  getPriorityListForGuide: new EndpointDefinition<
    PriorityContactViewDto,
    null,
    { guideId: string; includeMemberDetails?: boolean }
  >({
    name: 'getPriorityListForGuide',
    route: '/users/priority-contact/guide/:guideId',
    method: 'GET',
  }),
};
